
/*

hail




 */


// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import 'slick-carousel';

import basicNavigation from './header/header-basic';

import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

$(function () {

    basicNavigation();


    $('.carousel .slick').slick({
        lazyLoad: 'ondemand',
        autoplay: true,
        autoplaySpeed: 10000,
        fade: true,
        arrows: false
    });

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });


    $('.elemental-sponsors .slick').slick({
        slidesToShow: 5,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            prevArrow: $(element).parents('.elemental-hail').find('.hail-prev-arrow'),
            nextArrow: $(element).parents('.elemental-hail').find('.hail-next-arrow'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

    $('.event-carousel').each(function(index, element){
        //Build carousel options
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: $(element).parents('.elemental-event').find('.hail-prev-arrow'),
            nextArrow: $(element).parents('.elemental-event').find('.hail-next-arrow'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });



    $(document).ready(function() {
        if($('iframe.infoodle_embed_form').length > 0){
            $('iframe.infoodle_embed_form').attr('scrolling','no');
            var pageWidth = $(window).width();
            if (pageWidth > 1024) {
                $('iframe.infoodle_embed_form').height(1200);
            }
        }
    });

});
